export const verifyImage = (src: string) =>
  new Promise<void>((resolve, reject) => {
    const image = new Image()
    image.onload = () => resolve()
    image.onerror = (event) => {
      const err = new Error(`Failed to load image: ${src}`)
      ;(err as any).event = event
      reject(err)
    }
    image.onabort = (event) => {
      const err = new Error(`Image loading aborted: ${src}`)
      ;(err as any).event = event
      reject(err)
    }
    image.src = src
  })

const verifiedImages = new Map<string, Promise<void>>([])
export const verifyImageWithCache = (src: string) => {
  if (verifiedImages.has(src)) return verifiedImages.get(src)
  const promise = verifyImage(src)
  verifiedImages.set(src, promise)
  return promise
}
